import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '~/components/pages/PricingPage';
import { pricingMeta } from '~/content/pricing';
import { getDefaultFaq } from '~/lib/payload';
import { pageHeadMeta } from '~/lib/seo';
import pricingStylesHref from '~/styles/pricing.css?url';

export const Route = createFileRoute('/pricing')({
  loader: () => getDefaultFaq(),
  head: () =>
    pageHeadMeta({
      title: pricingMeta.title,
      description: pricingMeta.description,
      path: '/pricing',
      stylesheets: [pricingStylesHref],
    }),
  component: EnglishPricingPage,
});

function EnglishPricingPage() {
  return <PricingPage faqContent={Route.useLoaderData()} />;
}
